export const MAIN_SET_FETCHING = 'MAIN_SET_FETCHING'

export const PACKAGES_TYPE = 'PACKAGES_TYPE'
export const PACKAGES_GROUP = 'PACKAGES_GROUP'
export const PACKAGES_MODULE = 'PACKAGES_MODULE'



// WEBPACK FOOTER //
// ./src/store/types.js